<template>
  <v-row>
    <v-col cols="12">
      <v-row justify="space-between" align="center">
        <v-col cols="6">
          <h1>Сеты</h1>
        </v-col>
        <v-col cols="3" class="search-col">
          <v-text-field
              v-model="search"
              prepend-icon="mdi-magnify"
              label="Поиск"
              single-line
              hide-details
              clearable
          />
        </v-col>
      </v-row>
    </v-col>

    <v-col cols="12">
      <v-row>
        <v-col class="text-right">
          <v-btn
              color="primary"
              @click="navigateToCreate"
          >
            <v-icon left>mdi-plus</v-icon>
            Создать
          </v-btn>
        </v-col>
      </v-row>

      <v-data-table
          :headers="headers"
          :items="items"
          :search="search"
          :loading="loading"
          :options.sync="options"
          :footer-props="footerProps"
          :header-props="{ sortIcon: 'icon-custom-arrow' }"
          :items-per-page="-1"
          no-data-text="Пусто"
          no-results-text="По заданному запросу ничего не найдено"
          loading-text="Загрузка... Подождите пожалуйста"
          show-select
      >
        <template #item.price="{ item }">
          {{ item.price}} UAH
        </template>
        <template #item.actions="{ item }">
          <div class="text-right">
            <v-menu offset-y>
              <template #activator="{ on, attrs }">
                <v-btn
                    icon
                    small
                    v-bind="attrs"
                    v-on="on"
                >
                  <v-icon small>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-item @click="navigateToEdit(item.id)">
                  <v-list-item-icon>
                    <v-icon>mdi-pencil</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Редактировать</v-list-item-title>
                </v-list-item>

                <v-list-item @click="openDeleteDialog(item)">
                  <v-list-item-icon>
                    <v-icon color="error">mdi-delete</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Удалить</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
      </v-data-table>
    </v-col>

    <v-overlay :value="overlay" :z-index="4" />

    <ConfirmDialog
        v-model="deleteDialog.show"
        :title="deleteDialog.title"
        :message="deleteDialog.message"
        @confirm="handleDelete"
        @cancel="closeDeleteDialog"
    />

    <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.color"
        :timeout="snackbar.timeout"
        top
        right
    >
      {{ snackbar.message }}
      <template #action="{ attrs }">
        <v-btn
            text
            v-bind="attrs"
            @click="snackbar.show = false"
        >
          Закрыть
        </v-btn>
      </template>
    </v-snackbar>
  </v-row>
</template>

<script>
import CutleryItemService from '@/api/CutleryItemService'
import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
  name: 'CutleryItemIndex',

  components: {
    ConfirmDialog
  },

  data() {
    return {
      search: '',

      loading: true,
      overlay: false,

      deleteDialog: {
        show: false,
        title: 'Подтвердить удаление',
        message: 'Вы уверены, что хотите удалить этот элемент?',
        itemToDelete: null
      },

      snackbar: {
        show: false,
        message: '',
        color: 'success',
        timeout: 4000
      },

      options: {},
      footerProps: {
        itemsPerPageText: 'Элементов на страницу',
        pageText: '{0}-{1} из {2}',
        itemsPerPageAllText: 'Все',
        itemsPerPageOptions: [-1]
      },

      headers: [
        {
          text: 'Название',
          value: 'name',
          sortable: true
        },
        {
          text: 'Цена',
          value: 'price',
          sortable: true
        },
        {
          text: 'Действия',
          value: 'actions',
          sortable: false,
          width: '120px',
          align: 'center'
        }
      ],

      items: []
    }
  },

  computed: {
    selectedIds() {
      return this.selected.map(item => item.id)
    },

    hasSelectedItems() {
      return this.selected.length > 0
    }
  },

  watch: {
    options: {
      handler() {
        this.fetchData()
      },
      deep: true
    },

    search: {
      handler() {
      }
    }
  },

  mounted() {
    this.fetchData()
  },

  methods: {
    navigateToCreate() {
      this.$router.push({ name: 'cutlery-item-create' })
    },

    navigateToEdit(id) {
      this.$router.push({
        name: 'cutlery-item-edit',
        params: { id }
      })
    },

    openDeleteDialog(item) {
      this.deleteDialog.itemToDelete = item
      this.deleteDialog.show = true
    },

    closeDeleteDialog() {
      this.deleteDialog.show = false
      this.deleteDialog.itemToDelete = null
    },

    async fetchData() {
      this.loading = true

      try {
        const response = await CutleryItemService.list()
        this.items = response.data
      } catch (error) {
        this.handleError('Ошибка при загрузке данных', error)
      } finally {
        this.loading = false
      }
    },

    async handleDelete() {
      if (!this.deleteDialog.itemToDelete) return

      try {
        await CutleryItemService.remove(this.deleteDialog.itemToDelete.id)
        this.showSuccess('Элемент успешно удален')
        await this.fetchData()
      } catch (error) {
        this.handleError('Ошибка при удалении элемента', error)
      } finally {
        this.closeDeleteDialog()
      }
    },

    async deleteSelectedItems() {
      if (!this.hasSelectedItems) return

      try {
        const deletePromises = this.selectedIds.map(id =>
            CutleryItemService.remove(id)
        )

        await Promise.all(deletePromises)
        this.showSuccess(`Удалено элементов: ${this.selected.length}`)
        this.selected = []
        await this.fetchData()
      } catch (error) {
        this.handleError('Ошибка при массовом удалении', error)
      }
    },

    debounceSearch() {
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        this.fetchData()
      }, 300)
    },

    showSnackbar(message, color = 'success') {
      this.snackbar.message = message
      this.snackbar.color = color
      this.snackbar.show = true
    },

    handleError(message, error) {
      console.error(message, error)
      this.showSnackbar(message, 'error')
    },

    showSuccess(message) {
      this.showSnackbar(message, 'success')
    }
  },

  beforeDestroy() {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout)
    }
  }
}
</script>

<style lang="scss" scoped>

.v-btn--fab.v-size--x-small {
  width: 20px;
  height: 20px;

  .mdi::before {
    font-size: 12px;
  }
}

.filter-popup {
  position: absolute;
  width: 250px;
  z-index: 5;

  &:hover {
    cursor: auto;
  }

  &.v-card--link:focus::before {
    opacity: 0;
  }
}

</style>
